/**
 * URLInput
 *
 * Preconfigured `Input` wrapper for website URL entry.
 * Sets `type="url"`, `inputMode="url"`, and defaults `leftContent` to a link icon.
 * Callers may override `leftContent` with a different icon if needed.
 */
import * as React from 'react';
import { Input, type InputProps } from './Input';
import { Icon } from '../icons/Icon';

export type URLInputProps = Omit<InputProps, 'type'>;

export const URLInput = React.forwardRef<HTMLInputElement, URLInputProps>(
  ({ leftContent, ...props }, ref) => (
    <Input
      {...props}
      type='url'
      inputMode='url'
      leftContent={leftContent ?? <Icon name='link' />}
      ref={ref}
    />
  )
);

URLInput.displayName = 'URLInput';
